(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kinriot-mineral-codex-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCodex = (root) => {
      if (!root || root.dataset.kmcReady === 'true') return;
      const tabs = Array.from(root.querySelectorAll('[data-kmc-signal-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-kmc-signal-panel]'));
      const filterButtons = Array.from(root.querySelectorAll('[data-kmc-filter]'));
      const cards = Array.from(root.querySelectorAll('[data-kmc-stone]'));
      const resultCount = root.querySelector('[data-kmc-result-count]');

      const activateSignal = (key, focusTab = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.kmcSignalTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });
        panels.forEach((panel) => {
          const active = panel.dataset.kmcSignalPanel === key;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      const applyFilter = (key) => {
        let visible = 0;
        filterButtons.forEach((button) => {
          const active = button.dataset.kmcFilter === key;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        cards.forEach((card) => {
          const signals = card.dataset.kmcSignals.split(',').map((value) => value.trim()).filter(Boolean);
          const show = key === 'all' || signals.includes(key);
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (resultCount) resultCount.textContent = String(visible);
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateSignal(tab.dataset.kmcSignalTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          activateSignal(tabs[nextIndex].dataset.kmcSignalTab, true);
        });
      });

      filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.kmcFilter)));
      root.querySelectorAll('[data-kmc-show-matches]').forEach((link) => {
        link.addEventListener('click', () => applyFilter(link.dataset.kmcShowMatches));
      });
      const openLinkedCrystal = () => {
        const card = cards.find((item) => '#' + item.id === window.location.hash);
        if (!card) return;
        applyFilter('all');
        const details = card.querySelector('details');
        if (details) details.open = true;
        card.style.scrollMarginTop = '140px';
        requestAnimationFrame(() => {
          card.focus({ preventScroll: true });
          card.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      };
      window.addEventListener('hashchange', openLinkedCrystal);
      openLinkedCrystal();
      root.dataset.kmcReady = 'true';
    };

    document.querySelectorAll('[data-kmc-root]').forEach(initializeCodex);
    document.addEventListener('shopify:section:load', (event) => initializeCodex(event.target.querySelector('[data-kmc-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinriot-roadnest-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRoadNest = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

    const variantsNode = root.querySelector('[data-product-variants]');
    let variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    if (root.dataset.previewMode !== 'true') variants = variants.filter((variant) => /^\d+$/.test(String(variant.id)));
    const previewMode = root.dataset.previewMode === 'true';
    const currency = root.dataset.currency || 'USD';
    const form = root.querySelector('[data-product-form]');
    const primaryCta = root.querySelector('[data-primary-cta]');
    const status = root.querySelector('[data-form-status]');
    const sticky = root.querySelector('[data-sticky-bar]');
    const finalCta = root.querySelector('[data-final-cta]');
    let lastFocused;

    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);

    const showMedia = (mediaId) => {
      if (!mediaId || ![...root.querySelectorAll('[data-media-panel]')].some((panel) => panel.dataset.mediaPanel === String(mediaId))) return;
      root.querySelectorAll('[data-media-panel]').forEach((panel) => {
        const active = panel.dataset.mediaPanel === String(mediaId);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        const active = thumb.dataset.mediaThumb === String(mediaId);
        thumb.classList.toggle('is-active', active);
        if (thumb.hasAttribute('aria-pressed')) thumb.setAttribute('aria-pressed', String(active));
        else thumb.setAttribute('aria-selected', String(active));
      });
    };

    root.querySelectorAll('[data-media-thumb]').forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaThumb)));

    const groups = [...root.querySelectorAll('[data-option-group]')];
    const stickyCta = root.querySelector('[data-sticky-cta]');
    const selectedOptions = () => groups.map((group) => group.querySelector('[data-option-input]:checked')?.value);
    const selectedVariant = () => variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions()[index]));
    const syncPurchaseState = () => {
      const variant = selectedVariant();
      const busy = form.dataset.kinriotSubmitting === 'true';
      const available = previewMode || Boolean(variant?.available);
      primaryCta.disabled = busy || !available;
      if (stickyCta) {
        stickyCta.disabled = busy || !available;
        stickyCta.textContent = available ? root.dataset.addText : root.dataset.soldOutText;
      }
      root.querySelector('[data-add-label]').textContent = available ? root.dataset.addText : root.dataset.soldOutText;
    };
    const updateVariant = () => {
      const selections = selectedOptions();
      groups.forEach((group, index) => {
        group.querySelectorAll('[data-option-input]').forEach((input) => {
          const exists = variants.some((candidate) => candidate.options[index] === input.value && candidate.options.slice(0,index).every((option, before) => option === selections[before]));
          input.disabled = !exists;
          input.nextElementSibling?.classList.toggle('is-unavailable', !exists);
        });
        const selected = group.querySelector('[data-option-input]:checked');
        const output = group.querySelector('[data-selected-option]');
        if (selected && output) output.textContent = selected.value;
      });
      const variant = selectedVariant();
      form.querySelector('[data-variant-id]').value = variant?.id || '';
      syncPurchaseState();
      if (!variant) {
        root.querySelectorAll('[data-product-price],[data-cta-price],[data-sticky-price]').forEach((node) => node.textContent = '—');
        root.querySelector('[data-compare-price]').hidden = true;
        return;
      }
      root.querySelectorAll('[data-product-price],[data-cta-price],[data-sticky-price]').forEach((node) => node.textContent = money(variant.price));
      const compare = root.querySelector('[data-compare-price]');
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      }
      const matchingPhoto = [...root.querySelectorAll('[data-gallery-color]')].find((panel) => panel.dataset.galleryColor && variant.options.includes(panel.dataset.galleryColor));
      if (matchingPhoto) showMedia(matchingPhoto.dataset.mediaPanel);
      else if (variant.featured_media?.id) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    form.addEventListener('kinriot:submitting', syncPurchaseState);
    form.addEventListener('submit', (event) => {
      if (previewMode || !selectedVariant()?.available) event.preventDefault();
    });
    updateVariant();

    root.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', updateVariant));

    const quantity = root.querySelector('[data-quantity]');
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.min(9, Number(quantity.value || 1) + 1); });

    if (previewMode) {
      primaryCta?.addEventListener('click', () => {
        status.textContent = 'Design preview — checkout remains disabled.';
        status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    const scrollToBuy = () => primaryCta?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    root.querySelector('[data-scroll-to-buy]')?.addEventListener('click', scrollToBuy);
    root.querySelector('[data-sticky-cta]')?.addEventListener('click', () => primaryCta.click());

    const fitDialog = root.querySelector('[data-fit-dialog]');
    root.querySelectorAll('[data-fit-open]').forEach((button) => button.addEventListener('click', () => {
      lastFocused = button;
      fitDialog?.showModal();
      sticky?.classList.remove('is-visible');
    }));
    root.querySelector('[data-fit-close]')?.addEventListener('click', () => fitDialog?.close());
    fitDialog?.addEventListener('click', (event) => { if (event.target !== fitDialog) return; const bounds = fitDialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) fitDialog.close(); });
    fitDialog?.addEventListener('close', () => lastFocused?.focus());

      if (sticky && primaryCta && 'IntersectionObserver' in window) {
      let primaryVisible = true;
      let finalVisible = false;
      const syncSticky = () => {
        root.dataset.purchaseControlsVisible = String(primaryVisible || finalVisible);
        const visible = !primaryVisible && primaryCta.getBoundingClientRect().bottom < 0 && !finalVisible && !fitDialog?.open;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
      };
      new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; syncSticky(); }, { threshold: .15 }).observe(primaryCta);
      if (finalCta) new IntersectionObserver(([entry]) => { finalVisible = entry.isIntersecting; syncSticky(); }, { threshold: .05 }).observe(finalCta);
      }
    };

    const initAll = (scope) => {
      if (scope.matches?.('[data-roadnest-product]')) initRoadNest(scope);
      scope.querySelectorAll?.('[data-roadnest-product]').forEach(initRoadNest);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinriot-travel-pdp-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTravelPdp = (root) => {
      if (!root || root.dataset.kpInitialized === 'true') return;
      root.dataset.kpInitialized = 'true';

      const panels = Array.from(root.querySelectorAll('[data-gallery-panel]'));
      const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
      const thumbList = root.querySelector('.kp-gallery-thumbs');
      const mobileGallery = window.matchMedia('(max-width: 719px)');

      const updateGalleryOrientation = () => {
        thumbList?.setAttribute('aria-orientation', mobileGallery.matches ? 'vertical' : 'horizontal');
      };

      const activateGalleryItem = (index, moveFocus = false) => {
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        thumbs.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        if (moveFocus) thumbs[index]?.focus();
      };

      updateGalleryOrientation();
      mobileGallery.addEventListener?.('change', updateGalleryOrientation);

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => activateGalleryItem(index));
        thumb.addEventListener('keydown', (event) => {
          const vertical = thumbList?.getAttribute('aria-orientation') === 'vertical';
          const previousKey = vertical ? 'ArrowUp' : 'ArrowLeft';
          const nextKey = vertical ? 'ArrowDown' : 'ArrowRight';
          let nextIndex = index;

          if (event.key === previousKey) nextIndex = (index - 1 + thumbs.length) % thumbs.length;
          else if (event.key === nextKey) nextIndex = (index + 1) % thumbs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = thumbs.length - 1;
          else return;

          event.preventDefault();
          activateGalleryItem(nextIndex, true);
        });
      });

      root.querySelectorAll('[data-preview-choice]').forEach((choice) => {
        choice.addEventListener('click', () => {
          const type = choice.dataset.previewChoice;
          root.querySelectorAll(`[data-preview-choice="${type}"]`).forEach((item) => {
            const selected = item === choice;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          const output = root.querySelector(`[data-choice-output="${type}"]`);
          if (output) output.textContent = choice.dataset.choiceLabel;
        });
      });

      const quantityOutput = root.querySelector('[data-quantity-output]');
      const updateQuantity = (change) => {
        if (!quantityOutput) return;
        const current = Number.parseInt(quantityOutput.textContent || '1', 10);
        quantityOutput.textContent = String(Math.min(9, Math.max(1, current + change)));
      };

      root.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => updateQuantity(-1));
      root.querySelector('[data-quantity-increase]')?.addEventListener('click', () => updateQuantity(1));

      const sizeSheet = root.querySelector('[data-size-sheet]');
      const closeSizeSheet = () => sizeSheet?.close();

      root.querySelectorAll('[data-size-sheet-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          if (!window.matchMedia('(max-width: 719px)').matches || !sizeSheet?.showModal) return;
          event.preventDefault();
          root.classList.add('is-size-sheet-open');
          document.documentElement.classList.add('kp-size-sheet-open');
          sizeSheet.showModal();
        });
      });

      sizeSheet?.querySelector('[data-size-sheet-close]')?.addEventListener('click', closeSizeSheet);
      sizeSheet?.addEventListener('click', (event) => {
        if (event.target === sizeSheet) closeSizeSheet();
      });
      sizeSheet?.addEventListener('close', () => {
        root.classList.remove('is-size-sheet-open');
        document.documentElement.classList.remove('kp-size-sheet-open');
      });

      root.querySelectorAll('[data-preview-cta]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const message = button.closest('[data-sticky-cta]')
            ? root.querySelector('[data-preview-toast]')
            : root.querySelector('[data-preview-message]');
          if (!message) return;
          message.hidden = false;
          window.setTimeout(() => {
            message.hidden = true;
          }, 4200);
        });
      });
    };

    document.querySelectorAll('[data-kp-travel-pdp]').forEach(initializeTravelPdp);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-kp-travel-pdp]').forEach(initializeTravelPdp);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.krCatalogReady) return;
      root.dataset.krCatalogReady = 'true';
      const sortForm = root.querySelector('[data-kr-sort-form]');
      const sortSelect = root.querySelector('[data-kr-sort]');
      const applySort = (event) => {
        event.preventDefault();
        if (!sortSelect) return;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.assign(url.href);
      };
      sortForm?.addEventListener('submit', applySort);
      sortSelect?.addEventListener('change', applySort);
      const applyColor = (card, button, replaceImage) => {
        if (!button || (replaceImage && button.disabled)) return;
        const name = button.dataset.colorName;
        const live = card.dataset.krCardLive === 'true';
        card.querySelectorAll('[data-kr-card-color]').forEach((option) => option.setAttribute('aria-pressed', String(option === button)));
        const selected = card.querySelector('[data-kr-selected-color]');
        if (selected) selected.textContent = name;
        const summary = card.querySelector('[data-kr-color-summary]');
        if (summary) summary.setAttribute('aria-label', `${name}`);
        if (live && replaceImage && button.dataset.variantId) {
          const price = card.querySelector('[data-kr-card-price-amount]');
          if (price) price.textContent = button.dataset.variantPrice;
          const compare = card.querySelector('[data-kr-card-compare-price]');
          if (compare) {
            compare.textContent = button.dataset.variantComparePrice || '';
            compare.hidden = !button.dataset.variantComparePrice;
          }
          const discount = card.querySelector('[data-kr-card-discount]');
          if (discount) {
            discount.textContent = button.dataset.variantDiscount || '';
            discount.hidden = !button.dataset.variantDiscount;
          }
          const stock = card.querySelector('[data-kr-card-stock]');
          if (stock) stock.hidden = button.dataset.variantAvailable === 'true';
        }
        if (replaceImage && button.dataset.colorImage) {
          let image = card.querySelector('.kr-card-main-image');
          if (!image) {
            image = document.createElement('img');
            image.className = 'kr-card-main-image';
            image.width = 800;
            image.height = 800;
            card.querySelector('.kr-card-placeholder')?.replaceWith(image);
          }
          image.removeAttribute('srcset');
          image.sizes = card.dataset.imageSizes || '46vw';
          if (button.dataset.colorSrcset) image.srcset = button.dataset.colorSrcset;
          image.src = button.dataset.colorImage;
          image.alt = button.dataset.colorAlt;
          image.loading = 'eager';
          card.dataset.colorPicked = 'true';
        }
        card.querySelectorAll('[data-kr-card-link]').forEach((link) => {
          const base = link.dataset.baseLink;
          if (!base) return;
          try {
            const url = new URL(base, window.location.href);
            if (live) {
              url.searchParams.delete('color');
              if (replaceImage && button.dataset.variantId) url.searchParams.set('variant', button.dataset.variantId);
              else url.searchParams.delete('variant');
            } else url.searchParams.set('color', name);
            link.href = url.href;
          } catch (_) {}
        });
      };
      root.querySelectorAll('[data-kr-card]').forEach((card) => {
        const colors = [...card.querySelectorAll('[data-kr-card-color]')];
        const enabledColors = colors.filter((button) => !button.disabled);
        colors.forEach((button) => {
          button.addEventListener('click', () => applyColor(card, button, true));
          button.addEventListener('keydown', (event) => {
            if (!enabledColors.length || button.disabled) return;
            const index = enabledColors.indexOf(button);
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % enabledColors.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + enabledColors.length) % enabledColors.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = enabledColors.length - 1;
            else return;
            event.preventDefault();
            enabledColors[next].focus();
            applyColor(card, enabledColors[next], true);
          });
        });
      });
      root.querySelectorAll('[data-kr-filter]').forEach((button) => button.addEventListener('click', () => {
        root.querySelectorAll('[data-kr-filter]').forEach((filter) => {
          filter.classList.toggle('is-active', filter === button);
          filter.setAttribute('aria-pressed', String(filter === button));
        });
        const cards = [...root.querySelectorAll('[data-kr-category]')];
        cards.forEach((card) => { card.hidden = button.dataset.krFilter !== 'all' && card.dataset.krCategory !== button.dataset.krFilter; });
        const empty = root.querySelector('[data-kr-filter-empty]');
        if (empty) empty.hidden = cards.some((card) => !card.hidden);
      }));
    };
    document.querySelectorAll('[data-kr-catalog]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-kr-catalog]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-site-header')) {
    customElements.define('kr-site-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.closeMenus = (focus) => {
          const active = this.querySelector('details[open]');
          this.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
          if (focus && active) active.querySelector('summary')?.focus();
        };
        document.addEventListener('click', event => {
          this.querySelectorAll('details[open]').forEach(menu => {
            if (!menu.contains(event.target)) menu.open = false;
          });
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.querySelector('details[open]')) {
            event.preventDefault();
            this.closeMenus(true);
          }
        }, options);
        this.querySelector('.kr-menu-close')?.addEventListener('click', () => this.closeMenus(true), options);
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href]');
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
          const destination = new URL(link.href, window.location.href);
          if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) {
            clearTimeout(this.anchorCloseTimer);
            this.anchorCloseTimer = setTimeout(() => this.closeMenus(false), 0);
          }
        }, options);
        document.addEventListener('focusin', event => {
          if (!this.contains(event.target)) this.closeMenus(false);
        }, options);
        window.addEventListener('pageshow', () => this.closeMenus(false), options);
        this.breakpoint = matchMedia('(min-width: 1180px)');
        this.breakpoint.addEventListener('change', () => this.closeMenus(false), options);
        this.querySelectorAll('.kr-desktop-nav > .kr-nav-group').forEach(menu => {
          let closeTimer;
          const desktopHover = () => matchMedia('(min-width:1180px) and (hover:hover) and (pointer:fine)').matches;
          menu.addEventListener('pointerenter', () => {
            if (!desktopHover()) return;
            clearTimeout(closeTimer);
            this.querySelectorAll('.kr-desktop-nav > .kr-nav-group[open]').forEach(other => { if (other !== menu) other.open = false; });
            menu.open = true;
          }, options);
          menu.addEventListener('pointerleave', () => {
            if (!desktopHover()) return;
            closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180);
          }, options);
          menu.addEventListener('focusout', () => { closeTimer = setTimeout(() => { if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false; }, 0); }, options);
          this.controller.signal.addEventListener('abort', () => clearTimeout(closeTimer), { once:true });
        });
        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--kr-header-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);
      }
      disconnectedCallback() {
        clearTimeout(this.anchorCloseTimer);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const initialize = (root) => {
      if (cleanups.has(root)) return;
      const track = root.querySelector('[data-kr-journal-track]');
      const cards = [...root.querySelectorAll('[data-kr-journal-card]')];
      if (!track || !cards.length) return;
      const controls = root.querySelector('[data-kr-journal-controls]');
      const previous = root.querySelector('[data-kr-journal-previous]');
      const next = root.querySelector('[data-kr-journal-next]');
      const counter = root.querySelector('[data-kr-journal-counter]');
      const mobile = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      let frame;
      let index = 0;
      const update = () => {
        frame = undefined;
        const left = track.getBoundingClientRect().left;
        index = cards.reduce((closest, card, position) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[closest].getBoundingClientRect().left - left) ? position : closest, 0);
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === cards.length - 1;
        if (counter) {
          counter.textContent = `${index + 1} / ${cards.length}`;
          counter.setAttribute('aria-label', cards[index].dataset.slideLabel);
        }
      };
      const scheduleUpdate = () => {
        if (frame === undefined) frame = window.requestAnimationFrame(update);
      };
      const show = (position) => {
        if (!mobile.matches) return;
        const destination = Math.max(0, Math.min(cards.length - 1, position));
        const left = cards[destination].offsetLeft - cards[0].offsetLeft;
        track.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      track.addEventListener('scroll', scheduleUpdate, { passive: true, signal: events.signal });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !mobile.matches) return;
        if (event.key === 'ArrowLeft') show(index - 1);
        else if (event.key === 'ArrowRight') show(index + 1);
        else if (event.key === 'Home') show(0);
        else if (event.key === 'End') show(cards.length - 1);
        else return;
        event.preventDefault();
      }, { signal: events.signal });
      previous?.addEventListener('click', () => show(index - 1), { signal: events.signal });
      next?.addEventListener('click', () => show(index + 1), { signal: events.signal });
      root.addEventListener('shopify:block:select', (event) => {
        const position = cards.findIndex((card) => card.dataset.krJournalBlock === event.detail.blockId);
        if (position >= 0) show(position);
      }, { signal: events.signal });
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(track);
      if (controls) controls.hidden = false;
      update();
      cleanups.set(root, () => {
        events.abort();
        observer.disconnect();
        if (frame !== undefined) window.cancelAnimationFrame(frame);
        cleanups.delete(root);
      });
    };
    document.querySelectorAll('[data-kr-journal]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-kr-journal]').forEach(initialize));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-kr-journal]').forEach((root) => cleanups.get(root)?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kr-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kr-scene-carousel')) {
    customElements.define('kr-scene-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.eventOptions = { signal: this.abortController.signal };
        this.track = this.querySelector('.kr-scenes__track');
        if (!this.track) return;
        this.slides = [...this.querySelectorAll('[data-scene-slide]')];
        this.previous = this.querySelector('[data-scene-previous]');
        this.next = this.querySelector('[data-scene-next]');
        this.currentLabel = this.querySelector('[data-scene-current]');
        this.hoverQuery = matchMedia('(hover: hover) and (pointer: fine)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.pairs = [...this.querySelectorAll('[data-scene-hotspot]')].map(button => {
          const panel = document.getElementById(button.dataset.sceneHotspot);
          const pair = { button, panel, hovered: false, home: panel.parentNode, next: panel.nextSibling };
          if (!panel.showPopover) {
            panel.removeAttribute('popover');
            document.body.appendChild(panel);
            pair.portaled = true;
          }
          button.addEventListener('pointerdown', () => { this.pointerButton = button; }, this.eventOptions);
          button.addEventListener('pointerup', () => { this.pointerButton = null; }, this.eventOptions);
          button.addEventListener('pointercancel', () => { this.pointerButton = null; }, this.eventOptions);
          button.addEventListener('pointerenter', event => {
            if (event.pointerType === 'touch' || !this.hoverQuery.matches) return;
            pair.hovered = true;
            this.openProduct(pair, false);
          }, this.eventOptions);
          button.addEventListener('pointerleave', () => {
            pair.hovered = false;
            this.deferClose(pair);
          }, this.eventOptions);
          button.addEventListener('focus', () => {
            if (!this.suppressFocus && this.pointerButton !== button) this.openProduct(pair, false);
          }, this.eventOptions);
          button.addEventListener('blur', () => this.deferClose(pair), this.eventOptions);
          button.addEventListener('click', event => {
            event.preventDefault();
            this.pointerButton = null;
            if (this.active === pair && this.pinned) this.closeProduct(false);
            else this.openProduct(pair, true);
          }, this.eventOptions);
          panel.addEventListener('pointerenter', () => {
            pair.hovered = true;
            clearTimeout(this.closeTimer);
          }, this.eventOptions);
          panel.addEventListener('pointerleave', () => {
            pair.hovered = false;
            this.deferClose(pair);
          }, this.eventOptions);
          panel.addEventListener('focusin', () => clearTimeout(this.closeTimer), this.eventOptions);
          panel.addEventListener('focusout', () => this.deferClose(pair), this.eventOptions);
          panel.addEventListener('toggle', event => {
            if (event.newState === 'closed' && this.active === pair) this.closeProduct(false);
          }, this.eventOptions);
          panel.querySelector('[data-scene-close]')?.addEventListener('click', event => {
            event.preventDefault();
            this.closeProduct(true);
          }, this.eventOptions);
          return pair;
        });
        this.previous?.addEventListener('click', () => this.move(-1), this.eventOptions);
        this.next?.addEventListener('click', () => this.move(1), this.eventOptions);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.slides.length - 1);
          }
        }, this.eventOptions);
        this.track.addEventListener('scroll', () => {
          this.closeProduct(false);
          this.scheduleControls();
        }, { ...this.eventOptions, passive: true });
        document.addEventListener('pointerdown', event => {
          if (this.active && !this.active.button.contains(event.target) && !this.active.panel.contains(event.target)) this.closeProduct(false);
          if (!event.target.closest?.('[data-scene-hotspot]')) this.pointerButton = null;
        }, this.eventOptions);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.active) {
            event.preventDefault();
            this.closeProduct(true);
          }
        }, this.eventOptions);
        document.addEventListener('scroll', event => {
          if (this.active && !this.active.panel.contains(event.target)) this.schedulePosition();
        }, { ...this.eventOptions, capture: true, passive: true });
        window.addEventListener('resize', () => {
          this.scheduleControls();
          this.schedulePosition();
        }, this.eventOptions);
        window.visualViewport?.addEventListener('resize', () => this.schedulePosition(), this.eventOptions);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.sceneBlock === event.detail.blockId);
          if (index !== -1) this.goTo(index);
        }, this.eventOptions);
        this.resizeObserver = new ResizeObserver(() => {
          this.scheduleControls();
          this.schedulePosition();
        });
        this.resizeObserver.observe(this.track);
        this.pairs.forEach(pair => this.resizeObserver.observe(pair.panel));
        this.updateControls();
      }
      nearestIndex() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft <= 2) return 0;
        if (maximum > 2 && this.track.scrollLeft >= maximum - 2) return this.slides.length - 1;
        const trackCenter = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        let index = 0;
        let distance = Infinity;
        this.slides.forEach((slide, slideIndex) => {
          const bounds = slide.getBoundingClientRect();
          const currentDistance = Math.abs(bounds.left + bounds.width / 2 - trackCenter);
          if (currentDistance < distance) { index = slideIndex; distance = currentDistance; }
        });
        return index;
      }
      updateControls() {
        if (!this.slides.length) return;
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= maximum - 2;
        if (this.previous) this.previous.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
        if (this.currentLabel) this.currentLabel.textContent = String(atEnd ? this.slides.length : this.nearestIndex() + 1);
      }
      scheduleControls() {
        if (this.controlsFrame) return;
        this.controlsFrame = requestAnimationFrame(() => { this.controlsFrame = 0; this.updateControls(); });
      }
      move(direction) {
        this.goTo(Math.max(0, Math.min(this.slides.length - 1, this.nearestIndex() + direction)));
      }
      goTo(index) {
        const slide = this.slides[index];
        if (!slide) return;
        this.closeProduct(false);
        const bounds = slide.getBoundingClientRect();
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const desired = this.track.scrollLeft + bounds.left - this.track.getBoundingClientRect().left + (bounds.width - this.track.clientWidth) / 2;
        const left = Math.max(0, Math.min(maximum, desired));
        this.track.scrollTo({ left, behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
      }
      openProduct(pair, pinned) {
        clearTimeout(this.closeTimer);
        if (this.active === pair) {
          if (pinned) this.pinned = true;
          this.positionProduct();
          return;
        }
        this.closeProduct(false);
        this.active = pair;
        this.pinned = pinned;
        pair.button.setAttribute('aria-expanded', 'true');
        pair.panel.style.visibility = 'hidden';
        pair.panel.dataset.open = 'true';
        if (pair.panel.showPopover) pair.panel.showPopover();
        this.positionProduct();
        pair.panel.style.visibility = '';
      }
      deferClose(pair) {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (this.active !== pair || this.pinned || pair.hovered || pair.button === document.activeElement || pair.panel.contains(document.activeElement)) return;
          this.closeProduct(false);
        }, 280);
      }
      closeProduct(restoreFocus) {
        clearTimeout(this.closeTimer);
        if (!this.active) return;
        const pair = this.active;
        this.active = null;
        this.pinned = false;
        pair.button.setAttribute('aria-expanded', 'false');
        if (pair.panel.hidePopover && pair.panel.matches(':popover-open')) pair.panel.hidePopover();
        delete pair.panel.dataset.open;
        if (restoreFocus) {
          this.suppressFocus = true;
          pair.button.focus({ preventScroll: true });
          queueMicrotask(() => { this.suppressFocus = false; });
        }
      }
      schedulePosition() {
        if (!this.active || this.positionFrame) return;
        this.positionFrame = requestAnimationFrame(() => { this.positionFrame = 0; this.positionProduct(); });
      }
      positionProduct() {
        if (!this.active) return;
        const { button, panel } = this.active;
        const anchor = button.getBoundingClientRect();
        const view = window.visualViewport;
        const viewportLeft = view?.offsetLeft || 0;
        const viewportTop = view?.offsetTop || 0;
        const viewportWidth = view?.width || innerWidth;
        const viewportHeight = view?.height || innerHeight;
        if (anchor.bottom < viewportTop || anchor.top > viewportTop + viewportHeight || anchor.right < viewportLeft || anchor.left > viewportLeft + viewportWidth) { this.closeProduct(false); return; }
        const margin = 12;
        const gap = 12;
        panel.style.maxWidth = `${Math.max(1, viewportWidth - margin * 2)}px`;
        panel.style.maxHeight = `${Math.max(1, viewportHeight - margin * 2)}px`;
        const bounds = panel.getBoundingClientRect();
        const rightSpace = viewportLeft + viewportWidth - anchor.right - margin;
        const leftSpace = anchor.left - viewportLeft - margin;
        let left;
        let top;
        if (rightSpace >= bounds.width + gap) {
          left = anchor.right + gap;
          top = anchor.top + anchor.height / 2 - bounds.height / 2;
        } else if (leftSpace >= bounds.width + gap) {
          left = anchor.left - bounds.width - gap;
          top = anchor.top + anchor.height / 2 - bounds.height / 2;
        } else {
          left = anchor.left + anchor.width / 2 - bounds.width / 2;
          const belowSpace = viewportTop + viewportHeight - anchor.bottom - margin;
          const aboveSpace = anchor.top - viewportTop - margin;
          top = belowSpace >= bounds.height + gap || belowSpace >= aboveSpace ? anchor.bottom + gap : anchor.top - bounds.height - gap;
        }
        left = Math.max(viewportLeft + margin, Math.min(left, viewportLeft + viewportWidth - bounds.width - margin));
        top = Math.max(viewportTop + margin, Math.min(top, viewportTop + viewportHeight - bounds.height - margin));
        panel.style.setProperty('--kr-popup-left', `${Math.round(left)}px`);
        panel.style.setProperty('--kr-popup-top', `${Math.round(top)}px`);
      }
      disconnectedCallback() {
        this.closeProduct(false);
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.controlsFrame);
        cancelAnimationFrame(this.positionFrame);
        this.pairs?.forEach(pair => {
          if (pair.portaled) pair.home.insertBefore(pair.panel, pair.next?.parentNode === pair.home ? pair.next : null);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
